export default "__VITE_ASSET__3Sa_3goK__"